import { cn } from "@babybjorn/ui";
import type { FC } from "react";
import * as s from "./BackgroundTheme.module.scss";

type Props = {
	themeColor?: string;
};

const BackgroundTheme: FC<Props> = ({ themeColor }) => {
	themeColor =
		!themeColor || themeColor === "undefined" ? "#f3e4de" : themeColor;
	return (
		<div className={cn(s.theme)} style={{ backgroundColor: themeColor }} />
	);
};

export default BackgroundTheme;
